var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrapper"},[_c('div',{staticClass:"button-menu",on:{"click":_vm.onClick}},[(_vm.notice)?_c('div',{staticClass:"notice"}):_vm._e(),(_vm.hasActiveVacation)?_c('div',{staticClass:"active-vacation"}):_vm._e(),_c('n-icon',{attrs:{"name":"burger-menu","outline":"","color":"accent"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }